import { useSelector } from 'react-redux'

import { partnershipAccountTypeSelector } from '../../../modules/selectors/app'

import { RIGHTS_HOLDER_TYPE } from '../../../constants/selfAccounts'

export default function useIsInternalAdCreation() {
  const partnershipAccountType = useSelector(partnershipAccountTypeSelector)

  // all users which are not rights_holder type, can create only internal ads
  return partnershipAccountType !== RIGHTS_HOLDER_TYPE
}
